import { ReactElement } from 'react';

import { DocplannerHealthcareProviderConfiguration } from '@dreryk/egabinet-docplanner-frontend-api';

import { Message, MessageType } from '@dreryk/react-components';

import { PageLoader } from '../common/PageLoader';
import { docplannerTranslationKeys } from '../translations';

import { useDocplannerIntegrationConfigurationQuery } from './integration.hooks';

type DocplannerIntegrationConfigurationLoaderRenderProps = {
   docplannerIntegrationConfiguration: DocplannerHealthcareProviderConfiguration | null;
   updateDocplannerConfiguration: (newDocplannerConfiguration: DocplannerHealthcareProviderConfiguration) => void;
};

type DocplannerIntegrationConfigurationLoaderProps = {
   readonly children: (renderProps: DocplannerIntegrationConfigurationLoaderRenderProps) => ReactElement;
};

export const DocplannerIntegrationConfigurationLoader = (
   props: DocplannerIntegrationConfigurationLoaderProps
): ReactElement => {
   const {
      data: docplannerIntegrationConfiguration,
      loading: docplannerIntegrationConfigurationLoading,
      error: docplannerIntegrationConfigurationError,
      setData: setDocplannerIntegrationConfiguration,
   } = useDocplannerIntegrationConfigurationQuery();

   if (docplannerIntegrationConfigurationLoading) {
      return <PageLoader testId={'docplannerIntegrationConfiguration'} />;
   }

   if (docplannerIntegrationConfigurationError) {
      return (
         <Message
            testId={'docplannerIntegrationConfigurationFetchError'}
            type={MessageType.NEGATIVE}
            label={docplannerTranslationKeys.integration.docplannerConfigurationFetchError}
            displayIndicator
         />
      );
   }

   return props.children({
      docplannerIntegrationConfiguration: docplannerIntegrationConfiguration ?? null,
      updateDocplannerConfiguration: setDocplannerIntegrationConfiguration,
   });
};
